import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import FileUpload from 'Components/FileUpload';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
// Material UI
import {
    Typography,
    Grid
} from '@mui/material';
import { Alert } from '@mui/material';
// Components
import { Button, Form, Select } from 'Components';
import { useFileUpload } from 'Core/hooks';
import { NotificationManager } from 'Components/Notifications';

// Actions
import {
    importLandmark,
    mapLandmarkImportModal,
    loadFileCsvLandmark,
    getUrlFileAttachmentLandmark
} from "Redux/actions";

import { resetLandmarkImportState as clearRedux } from '../landmarkImport/redux/slice';

const LandmarkImport = (props) => {
    // Intl
    const { messages } = useIntl();
    const delimiters = [{ id: ",", name: messages['settingsDriver_comma'] }, { id: ";", name: messages['settingsDriver_semicolon'] }];

    const loading = useSelector((state) => state.landmarkImportSliceRedux.loading);
    const csvFile = useSelector((state) => state.landmarkImportSliceRedux.csvFile);
    const urlFileCsv = useSelector((state) => state.landmarkImportSliceRedux.urlFileCsv);

    const openImport = useSelector((state) => state.realtimeMapLandmarkCreateEditModuleRedux.openImport);
    // Hooks
    const dispatch = useDispatch();
    const formRef = useRef();
    const filesUpload = useFileUpload([]);
    // State local
    const [delimiter, setDelimiter] = useState({
        id:'',
        name: messages['select']
    });
    const [disableButton, setdisableButton] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        message: "",
        type: ""
    });


    const handleClose = useCallback(() => {
        dispatch(mapLandmarkImportModal(false));
        dispatch(clearRedux())
        setErrorMessage({
            message: "",
            type: ""
        });
    });



    useEffect(() => {
        if (csvFile && openImport) {
            let ListDriver = csvToArray(csvFile, delimiter.id);
            if (ListDriver?.length && !ListDriver[0]?.hasOwnProperty('Tags')) {
                setErrorMessage({
                    message: messages['settingsDriver_error_delimiter'],
                    type: "error"
                });
               
            }else{

                let error = '';
                const allMissingFields = new Set();
                let hasAddressError = false;
                
                ListDriver.forEach((data) => {
                    if (data?.Tags) {
                        // Accumulate missing fields
                        if (!data.Name) allMissingFields.add('Name');
                        if (!data.Tags) allMissingFields.add('Tags');
                        if (!data.Radius) allMissingFields.add('Radius');
                        
                        // Check address errors
                        if ((!data.Address && !data.Latitude) || (!data.Address && !data.Longitude)) {
                            hasAddressError = true;
                        }
                    }
                });
                
                // Generate error message
                if (allMissingFields.size > 0) {
                    const missingFieldsText = Array.from(allMissingFields).join(', ');
                    error = `${messages['mapLandmarkImport_fieldsRequied']}. ${messages['mapLandmarkImport_columnError']}: ${missingFieldsText}`;
                } else if (hasAddressError) {
                    error = messages['mapLandmarkImport_fieldsAdressRequied'];
                }
    
                if (error.length > 0) {
                    setErrorMessage({
                        message: error,
                        type: "error"
                    });
              
                } else {
                    setdisableButton(true)
                    NotificationManager.success(
                        messages['settingsDriver_error_started'],
                        messages['mapLandmarkImport_ImportTitle'],
                        3000,
                        () => { },
                        null,
                        'success',
                        null
                    );
                    dispatch(importLandmark({ fileKey: filesUpload.value[0].fileKey, delimiter: delimiter.id }));
                    handleClose();
                }
            }
        }
    }, [csvFile, openImport]);

    useEffect(() => {
        if (urlFileCsv) {
            dispatch(loadFileCsvLandmark({ Url: urlFileCsv }));
        }
    }, [urlFileCsv]);

    const UploadInfo = () => {

        if (filesUpload.value.length < 1) {
            setErrorMessage({
                message: messages['settingsDriver_error_required'],
                type: "error"
            });
            return false;
        }
        dispatch(getUrlFileAttachmentLandmark({ id: filesUpload.value[0].id }));
    }

    const csvToArray = (str, delimiter = ",") => {
        str = str.replace('\r', '');
        str = str.replace('(FT)', '');
        const header_cols = str.slice(0, str.indexOf("\n")).split(delimiter);
        const row_data = str.slice(str.indexOf("\n") + 1).split("\n");
        let response = [];
        row_data.forEach((row) => {
            const values = delimiter==','?row.split(/,(?![^"]*"(?:,|$))/):row.split(delimiter);
            let formatRow = new Object();
            header_cols.forEach((header, index) => {
                if (header && header !== '') {
                    let value = (typeof values[index] !== 'undefined') ? values[index] : '';
                    value = value.replace('\"', '');
                    formatRow[`${header}`] = value.replace('"', '');
                }
            });
            response.push(formatRow);
        });
        return response;
    }


    return (
        <>
            <Modal
                title={messages['mapLandmarkImport_ImportTitle']}
                open={openImport}
                loading={false}
                position="right"
                size="small"
                className="modal-top-0"
                headerStyle={{
                    top: 0
                }}
                handleClose={handleClose}
            >
                <ModalBody>
                    <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>
                        {errorMessage.message &&
                            <Alert severity={errorMessage.type} onClose={() => { setErrorMessage("") }}>{errorMessage.message}</Alert>
                        }
                        <Form
                            ref={formRef}
                            onValidSubmit={UploadInfo}
                        >
                            <div style={{ padding: 24 }}>

                                <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
                                    <Grid item sm={12}>
                                        <Button
                                            type="button"
                                            className="btn-blue"
                                            style={{ width: '100%' }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                let delimiterSelected = delimiter?.id?delimiter?.id:',';
                                                let csvContent = `Name${delimiterSelected}Address${delimiterSelected}Latitude${delimiterSelected}Longitude${delimiterSelected}Radius(FT)${delimiterSelected}Tags${delimiterSelected}Notes\n`;
                                                let a = document.createElement('a');
                                                a.href = URL.createObjectURL(
                                                    new Blob([csvContent], {
                                                        type: 'text/csv;encoding:utf-8;charset=UTF-8',
                                                    }),
                                                );
                                                a.setAttribute('download', 'landmarks_format.csv');
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            }}
                                        >
                                            {messages['mapLandmarkImport_downloadTemplate']}
                                        </Button>
                                    </Grid>
                                    <Grid item sm={12}>
                                        <Select
                                            id="delimiter"
                                            label={messages['settingsDriver_delimiter']}
                                            placeholder={messages['select']}
                                            valueField="id"
                                            textField="name"
                                            options={delimiters}
                                            value={delimiter}
                                            required
                                            onChange={(data) => {
                                                setDelimiter(data);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12}>
                                        <FileUpload
                                            {...filesUpload}
                                            label={`${messages['settingsDriver_file']} (CSV)`}
                                            placeholder={messages['mapLandmarkImport_chooseFile']}
                                            types=".csv"
                                            helpText={messages['mapLandmarkImport_formatSupport']}
                                            maxSize={5}
                                            disabled={filesUpload?.value?.length > 0 || !delimiter?.id}
                                            maxSizeMessage={`${messages['max']}: 5MB`}
                                        />
                                        <small className="form-text text-muted">{messages['mapLandmarkImport_maxSizeFile']}</small>
                                    </Grid>
                                </Grid>
                            </div>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter style={{ bottom: 50,textAlign:'right' }}>
                    <Button
                        onClick={handleClose}
                        disabled={disableButton}
                        className="btn-cancel"
                    >
                        {messages['cancel']}
                    </Button>

                    <Button
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            formRef.current.submit();
                        }}
                        disabled={disableButton || filesUpload?.value?.length === 0 }
                        className="btn-blue"
                    >
                        {messages['mapLandmarkImport_import']}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default LandmarkImport;